import { apiClient } from "../config";

async function getVectorLayersByCommunityId(
  communityId: string,
  layerType?: any,
  params?: any,
) {
  const typeQuery = layerType ? `?type=${layerType}` : "";
  const res = await apiClient.get(
    `/admin/communities/${communityId}/vector-layers${typeQuery}`,
    {
      params,
    },
  );
  return res.data;
}

export default getVectorLayersByCommunityId;
